import SvgIcon from '@mui/material/SvgIcon'

const UndoIcon = () => (
  <SvgIcon
    viewBox="0 0 16 16"
    sx={{
      width: 15,
      height: 15,
    }}>
    <path
      d="M3.78752 15.2875C3.50419 15.2875 3.26669 15.1917 3.07502 15C2.88336 14.8083 2.78752 14.5708 2.78752 14.2875C2.78752 14.0042 2.88336 13.7667 3.07502 13.575C3.26669 13.3833 3.50419 13.2875 3.78752 13.2875H9.88752C10.9375 13.2875 11.85 12.9542 12.625 12.2875C13.4 11.6208 13.7875 10.7875 13.7875 9.7875C13.7875 8.7875 13.4 7.95417 12.625 7.2875C11.85 6.62083 10.9375 6.2875 9.88752 6.2875H3.58752L5.48752 8.1875C5.67086 8.37083 5.76252 8.60417 5.76252 8.8875C5.76252 9.17083 5.67086 9.40417 5.48752 9.5875C5.30419 9.77083 5.07086 9.8625 4.78752 9.8625C4.50419 9.8625 4.27086 9.77083 4.08752 9.5875L0.487524 5.9875C0.387524 5.8875 0.316691 5.77917 0.275024 5.6625C0.233358 5.54583 0.212524 5.42083 0.212524 5.2875C0.212524 5.15417 0.233358 5.02917 0.275024 4.9125C0.316691 4.79583 0.387524 4.6875 0.487524 4.5875L4.08752 0.9875C4.27086 0.804166 4.50419 0.7125 4.78752 0.7125C5.07086 0.7125 5.30419 0.804166 5.48752 0.9875C5.67086 1.17083 5.76252 1.40417 5.76252 1.6875C5.76252 1.97083 5.67086 2.20417 5.48752 2.3875L3.58752 4.2875H9.88752C11.5042 4.2875 12.8917 4.8125 14.05 5.8625C15.2084 6.9125 15.7875 8.22083 15.7875 9.7875C15.7875 11.3542 15.2084 12.6625 14.05 13.7125C12.8917 14.7625 11.5042 15.2875 9.88752 15.2875H3.78752Z"
      fill="#4A6FB8"
    />
  </SvgIcon>
)

export default UndoIcon
